module.exports = __webpack_public_path__ + "static/cashew_nuts_vuon_1-6f2e6d611d502a84ddea8b7537bf8482.jpg";